const siteConfig = {
  brandName: "Bentomarket",
  logo: "/img/bentomarket-logo.svg",
  tagline: "thoughtful essentials for everyday living",
  description:
    "Useful, well-made home, kitchen, workspace and lifestyle essentials selected for everyday living.",
  contact: {
    email: "return@bentomarket.online",
    company: "Hong Kong Zhichenda Trading Co., Limited",
    address:
      "RM 5, UNIT B36, 7/F, WING TAI CENTRE, 12 HING YIP STREET, KWUN TONG, HONG KONG",
    hours: "Online customer support",
  },
  currency: "USD",
  currencySymbol: "$",
  shippingRate: 9.99,
};

export default siteConfig;
